import React from 'react'
import { CommonPage } from './common-page'

function CommonNoIndexPage({ children }) {
  return <CommonPage noIndex>{children}</CommonPage>
}

export default CommonNoIndexPage
